import { render, staticRenderFns } from "./o-payment-proceed-form.vue?vue&type=template&id=1151084c"
import script from "./o-payment-proceed-form.vue?vue&type=script&lang=js"
export * from "./o-payment-proceed-form.vue?vue&type=script&lang=js"
import style0 from "./o-payment-proceed-form.vue?vue&type=style&index=0&id=1151084c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports